export default "__VITE_ASSET__694b5421__"